module.exports={
	"Form": "LocationViewManifest",
	"Scope": "Location-View",
	"Descriptors":
	{
		"LocationDetails.Name":
		{
			"Name": "Name",
			"Hash": "Location-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Location-View-Identity",
				"Group": "Location-View-Identity"
			}
		},
		"LocationDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Location-View-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Location-View-Identity",
				"Group": "Location-View-Identity"
			}
		},
		"LocationDetails.Type":
		{
			"Name": "Type",
			"Hash": "Location-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details"
			}
		},
		"LocationDetails.Description":
		{
			"Name": "Description",
			"Hash": "Location-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details"
			}
		},
		"LocationDetails.ExternalLocationID":
		{
			"Name": "External Location ID",
			"Hash": "Location-View-ExternalLocationID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details"
			}
		},
		"LocationDetails.ParentIDLocation":
		{
			"Name": "Parent Location",
			"Hash": "Location-View-ParentIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details",
				"Entity": "Location",
				"SearchFields":
				[
					"Name",
					"Description",
					"QRCode"
				],
				"ReadOnly": true
			}
		},
		"LocationDetails.IDObservation":
		{
			"Name": "Photo",
			"Hash": "Location-View-IDObservation",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ObservationPhoto",
				"Row": "5",
				"Width": 12,
				"Section": "Location-View-Photo",
				"Group": "Location-View-Photo",
				"PhotoEntity": "Location",
				"ReadOnly": true
			}
		},
		"LocationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Location-View-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Location-View-Contact",
				"Group": "Location-View-Contact"
			}
		},
		"LocationDetails.Address":
		{
			"Name": "Address",
			"Hash": "Location-View-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 12,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.City":
		{
			"Name": "City",
			"Hash": "Location-View-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.State":
		{
			"Name": "State",
			"Hash": "Location-View-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "Location-View-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.Latitude":
		{
			"Name": "Location",
			"Hash": "Location-View-Latitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "GeolocationSelectorWithMap",
				"Row": "9",
				"Width": 12,
				"Section": "Location-View-Map",
				"Group": "Location-View-Map",
				"LatitudeAddress": "LocationDetails.Latitude",
				"LongitudeAddress": "LocationDetails.Longitude",
				"ReadOnly": true
			}
		},
		"LocationDetails.IDLocation":
		{
			"Name": "IDLocation",
			"Hash": "Location-View-IDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.GUIDLocation":
		{
			"Name": "GUIDLocation",
			"Hash": "Location-View-GUIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Location-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Location-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Location-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Location-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Location-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Location-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Location-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Location-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Photo",
			"Hash": "Location-View-Photo",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Photo",
					"Hash": "Location-View-Photo",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Location-View-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Location-View-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "Location-View-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "Location-View-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Map Location",
			"Hash": "Location-View-Map",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Map Location",
					"Hash": "Location-View-Map",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Location-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Location-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
